<template>
  <div class="text-center my-4" data-cy="loading-overlay-container">
    <b-spinner small type="grow" data-cy="loading-overlay-spinner"></b-spinner>
    <p data-cy="loading-overlay-message">{{ message }}</p>
  </div>
</template>

<script>
export default {
  name: "loading-overlay",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    message: {
      type: String,
      default: "Carregando..."
    }
  }
};
</script>
